import React from 'react';
import { ProfileContainer, ProfileGrid, GridItem } from './styles';

// Importar componentes
import ProfileHeader from './ProfileHeader';
import DailyBrief from './DailyBrief';
import SocialMediaSection from './SocialMediaSection';
import IdeologySection from './IdeologySection';
import ElectoralSection from './ElectoralSection';
import ThemesSection from './ThemesSection';
import TrajectorySection from './TrajectorySection';
import AchievementsSection from './AchievementsSection';
import BusinessSection from './BusinessSection';
import StrengthsSection from './StrengthsSection';
import PerceptionSection from './PerceptionSection';
import ProposalsSection from './ProposalsSection';

const PoliticalProfile = () => {
  return (
    <ProfileContainer>
      <ProfileHeader />

      <DailyBrief />

      <ProfileGrid>
        {/* Primera fila en desktop, responsiva en móvil */}
        <GridItem span={4}>
          <SocialMediaSection />
          <IdeologySection />
        </GridItem>
        
        <GridItem span={4}>
          <ElectoralSection />
          <ThemesSection />
        </GridItem>
        
        <GridItem span={4}>
          <ProposalsSection />
        </GridItem>
        
        {/* Segunda fila en desktop, responsiva en móvil */}
        <GridItem span={4} className="mobile-full-width">
          <BusinessSection />
          <StrengthsSection />
        </GridItem>
        
        <GridItem span={4} className="mobile-full-width">
          <TrajectorySection />
          <AchievementsSection />
        </GridItem>
        
        <GridItem span={4} className="mobile-full-width">
          <PerceptionSection />
        </GridItem>
      </ProfileGrid>
    </ProfileContainer>
  );
};

export default PoliticalProfile;